<template>
    <div>
        <b-modal
            :id="ModalId"
            size="xl"
            :no-close-on-backdrop="true"
            @shown="prepararDrag"
            :no-close-on-esc="true"
            scrollable
            centered
            :visible="true"
            :title="TitleWindow"
            @ok="this.emitEventOK"
            @hide="this.emitEventHide"
            :cancel-title="$t('Shared.BtnCancel')"
        >
            <Loading v-bind:IsLoading="load" />

            <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
                <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">
                    <div class="tab-pane fade show active" id="diag1_8" role="tabpanel">
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '1' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode1"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode1Description"
                                    v-bind:RefCode="'Diagnosis1'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '2' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode2"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode2Description"
                                    v-bind:RefCode="'Diagnosis2'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '3' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode3"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode3Description"
                                    v-bind:RefCode="'Diagnosis3'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '4' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode4"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode4Description"
                                    v-bind:RefCode="'Diagnosis4'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '5' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode5"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode5Description"
                                    v-bind:RefCode="'Diagnosis5'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '6' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode6"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode6Description"
                                    v-bind:RefCode="'Diagnosis6'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '7' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode7"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode7Description"
                                    v-bind:RefCode="'Diagnosis7'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '8' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode8"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode8Description"
                                    v-bind:RefCode="'Diagnosis8'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                        </b-row>
                    </div>

                    <div class="tab-pane fade" id="diag9_16" role="tabpanel">
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '9' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode9"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode9Description"
                                    v-bind:RefCode="'Diagnosis9'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    MdLookup
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '10' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode10"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode10Description"
                                    v-bind:RefCode="'Diagnosis10'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '11' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode11"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode11Description"
                                    v-bind:RefCode="'Diagnosis11'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '12' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode12"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode12Description"
                                    v-bind:RefCode="'Diagnosis12'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '13' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode13"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode13Description"
                                    v-bind:RefCode="'Diagnosis13'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '14' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode14"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode14Description"
                                    v-bind:RefCode="'Diagnosis14'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '15' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode15"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode15Description"
                                    v-bind:RefCode="'Diagnosis15'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '16' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode16"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode16Description"
                                    v-bind:RefCode="'Diagnosis16'"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    :IsDisabled="ReadOnly"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                        </b-row>
                    </div>

                    <div class="tab-pane fade" id="diag17_24" role="tabpanel">
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '17' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode17"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode17Description"
                                    v-bind:RefCode="'Diagnosis17'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '18' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode18"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode18Description"
                                    v-bind:RefCode="'Diagnosis18'"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    :IsDisabled="ReadOnly"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '19' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode19"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode19Description"
                                    v-bind:RefCode="'Diagnosis19'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '20' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode20"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode20Description"
                                    v-bind:RefCode="'Diagnosis20'"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    :IsDisabled="ReadOnly"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '21' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode21"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode21Description"
                                    v-bind:RefCode="'Diagnosis21'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '22' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode22"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode22Description"
                                    v-bind:RefCode="'Diagnosis22'"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    :IsDisabled="ReadOnly"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '23' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode23"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode23Description"
                                    v-bind:RefCode="'Diagnosis23'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '24' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode24"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode24Description"
                                    v-bind:RefCode="'Diagnosis24'"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    :IsDisabled="ReadOnly"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <div class="tab-pane fade" id="diag25" role="tabpanel">
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookupMultiple
                                    v-bind:modelFilter="modelFilter"
                                    v-bind:OptionParamList="ParamList"
                                    v-bind:Label="$t('Admission.Diagnosis', { num: '25' })"
                                    v-bind:ModelCode="itemsDiagnosis.diagcode25"
                                    v-bind:ModelDescription="itemsDiagnosis.diagCode25Description"
                                    v-bind:RefCode="'Diagnosis25'"
                                    :IsDisabled="ReadOnly"
                                    v-bind:Api="'DiagnosisICD10Providers'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'name'"
                                    :SearchTitle="$t('Shared.Diagnosis')"
                                    :GetValues="onCodeConditionOk"
                                    :InvalidFeedback="$t('Shared.InvalidCodeMsg')"
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </MdTabList>
        </b-modal>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import PatientService from '@/services/patient.service';
import DiagnosisService from '@/services/diagnosis.service';
import { EventBus } from '@/event-bus.js';
import Loading from '@/components/template/loading/Loading';

export default {
    mixins: [ShowMessage],
    props: {
        ModalId: String,
        PatientCode: String,
        TitleWindow: String,
        DateFrom: String,
        RecordId: String,
        ForUsefromMars: Boolean,
        MarsParam: Object,
        ReadOnly: Boolean,
        OpenInModal: Boolean
    },
    components: { Loading },
    data() {
        return {
            BaseFields: [
                { key: 'name', sortable: true, label: this.$t('Shared.Description') },
                { key: 'code', sortable: true, label: this.$t('Shared.Code') }
            ],
            load: true,
            tablist: [
                { title: this.$t('Shared.Diagnoses') + ' 1-8', link: '#diag1_8', active: true },
                { title: this.$t('Shared.Diagnoses') + ' 9-16', link: '#diag9_16' },
                { title: this.$t('Shared.Diagnoses') + ' 17-24', link: '#diag17_24' },
                { title: this.$t('Shared.Diagnoses') + ' 25', link: '#diag25' }
            ],
            itemsDiagnosis: {
                recordId: this.RecordId,
                patientCode: this.PatientCode,
                programName: '',
                dateFrom: this.DateFrom ? this.DateFrom : null,
                dateTo: null,
                diagcode1: '',
                diagcode2: '',
                diagcode3: '',
                diagcode4: '',
                diagcode5: '',
                diagcode6: '',
                diagcode7: '',
                diagcode8: '',
                diagcode9: '',
                diagcode10: '',
                diagcode11: '',
                diagcode12: '',
                diagcode13: '',
                diagcode14: '',
                diagcode15: '',
                diagcode16: '',
                diagcode17: '',
                diagcode18: '',
                diagcode19: '',
                diagcode20: '',
                diagcode21: '',
                diagcode22: '',
                diagcode23: '',
                diagcode24: '',
                diagcode25: '',
                diagCode1Description: '',
                diagCode2Description: '',
                diagCode3Description: '',
                diagCode4Description: '',
                diagCode5Description: '',
                diagCode6Description: '',
                diagCode7Description: '',
                diagCode8Description: '',
                diagCode9Description: '',
                diagCode10Description: '',
                diagCode11Description: '',
                diagCode12Description: '',
                diagCode13Description: '',
                diagCode14Description: '',
                diagCode15Description: '',
                diagCode16Description: '',
                diagCode17Description: '',
                diagCode18Description: '',
                diagCode19Description: '',
                diagCode20Description: '',
                diagCode21Description: '',
                diagCode22Description: '',
                diagCode23Description: '',
                diagCode24Description: '',
                diagCode25Description: ''
            },

            pendingChanges: false,
            clickOK: false,
            haveDiagnoses: false,
            ParamList: [
                {
                    code: 1,
                    description: this.$t('Shared.AllDiagnoses'),
                    resource: 'DiagnosisICD10Providers?'
                },
                {
                    code: 2,
                    description: this.$t('Shared.MostDiagnosesUsed'),
                    resource: 'DiagnosisICD10Providers?mustUsed=true'
                }
            ],
            modelFilter: {
                code: 1,
                description: this.$t('Shared.AllDiagnoses'),
                resource: 'DiagnosisICD10Providers'
            }
        };
    },

    methods: {
        emitEventOK() {
            this.clickOK = true;
            if (this.pendingChanges) {
                this.Save();
            }
        },

        emitEventHide(handled) {
            if (this.pendingChanges && !this.OpenInModal) {
                handled.preventDefault();
                this.$bvModal
                    .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                        title: this.$t('Shared.Diagnoses'),
                        okTitle: this.$t('Shared.Save'),
                        cancelTitle: this.$t('Shared.BtnDismiss'),
                        footerClass: 'p-2',
                        titleClass: 'modal-title modal-type-warning'
                    })
                    .then(value => {
                        if (!value) {
                            this.$emit('getCancel');
                            this.ResetProps();
                        }
                    });
            } else {
                if (this.clickOK) {
                    if (this.ForUsefromMars) {
                        let param = {
                            info: this.getTextResult(),
                            MarsParam: this.MarsParam
                        };
                        this.$emit('getCodeConditionOK', param);
                    } else {
                        this.$emit('getCodeConditionOK', this.getTextResult());
                    }
                } else {
                    this.$emit('getCancel');
                    this.ResetProps();
                }
            }
        },

        prepararDrag() {
            this.$nextTick(() => {
                const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
                if (!outer) {
                    console.warn('No se encontró el contenedor del modal');
                    return;
                }

                const dialog = outer.querySelector('.modal-dialog');
                const header = outer.querySelector('.modal-header');

                if (!dialog || !header) {
                    console.warn('No se encontró header o dialog');
                    return;
                }

                if (outer.classList.contains('is-draggable')) return;

                header.style.cursor = 'move';

                header.onmousedown = e => {
                    e.preventDefault();

                    // Obtener posición actual antes de tocar estilos
                    const rect = dialog.getBoundingClientRect();
                    const offsetX = e.clientX - rect.left;
                    const offsetY = e.clientY - rect.top;

                    // Fijar posición actual (solo en el primer movimiento)
                    dialog.style.width = `${rect.width}px`;
                    dialog.style.height = `${rect.height}px`;
                    dialog.style.position = 'fixed';
                    dialog.style.left = `${rect.left}px`;
                    dialog.style.top = `${rect.top}px`;
                    dialog.style.margin = 0;
                    dialog.style.transform = 'none';

                    const moveHandler = eMove => {
                        dialog.style.left = `${eMove.clientX - offsetX}px`;
                        dialog.style.top = `${eMove.clientY - offsetY}px`;
                    };

                    document.addEventListener('mousemove', moveHandler);
                    document.addEventListener(
                        'mouseup',
                        () => document.removeEventListener('mousemove', moveHandler),
                        { once: true }
                    );
                };
            });
        },

        ResetProps() {
            for (var i = 1; i <= 25; i++) {
                this.itemsDiagnosis['diagCode' + i] = '';
                this.itemsDiagnosis['diagCode' + i + 'Description'] = '';
            }
        },

        getTextResult() {
            let textResult = '';
            for (var i = 1; i <= 25; i++) {
                if (this.itemsDiagnosis['diagcode' + i])
                    textResult =
                        textResult +
                        this.itemsDiagnosis['diagcode' + i] +
                        ' - ' +
                        this.itemsDiagnosis['diagCode' + i + 'Description'] +
                        '\n';
            }
            return textResult;
        },

        getData() {
            PatientService.getPatientDiag(this.PatientCode)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.itemsDiagnosis = response.data;
                        this.itemsDiagnosis.patientCode = this.PatientCode;
                        this.itemsDiagnosis.recordId = this.RecordId;
                        this.itemsDiagnosis.dateFrom = this.DateFrom;
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        // network error
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.RetrieveInformation'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        onCodeConditionOk(result) {
            var type = result.FieldName;
            if (type.indexOf('Diagnosis') >= 0) {
                switch (type) {
                    case 'Diagnosis1':
                        this.itemsDiagnosis.diagcode1 = result.code;
                        this.itemsDiagnosis.diagCode1Description = result.description;
                        break;
                    case 'Diagnosis2':
                        this.itemsDiagnosis.diagcode2 = result.code;
                        this.itemsDiagnosis.diagCode2Description = result.description;
                        break;
                    case 'Diagnosis3':
                        this.itemsDiagnosis.diagcode3 = result.code;
                        this.itemsDiagnosis.diagCode3Description = result.description;
                        break;
                    case 'Diagnosis4':
                        this.itemsDiagnosis.diagcode4 = result.code;
                        this.itemsDiagnosis.diagCode4Description = result.description;
                        break;
                    case 'Diagnosis5':
                        this.itemsDiagnosis.diagcode5 = result.code;
                        this.itemsDiagnosis.diagCode5Description = result.description;
                        break;
                    case 'Diagnosis6':
                        this.itemsDiagnosis.diagcode6 = result.code;
                        this.itemsDiagnosis.diagCode6Description = result.description;
                        break;
                    case 'Diagnosis7':
                        this.itemsDiagnosis.diagcode7 = result.code;
                        this.itemsDiagnosis.diagCode7Description = result.description;
                        break;
                    case 'Diagnosis8':
                        this.itemsDiagnosis.diagcode8 = result.code;
                        this.itemsDiagnosis.diagCode8Description = result.description;
                        break;
                    case 'Diagnosis9':
                        this.itemsDiagnosis.diagcode9 = result.code;
                        this.itemsDiagnosis.diagCode9Description = result.description;
                        break;
                    case 'Diagnosis10':
                        this.itemsDiagnosis.diagcode10 = result.code;
                        this.itemsDiagnosis.diagCode10Description = result.description;
                        break;
                    case 'Diagnosis11':
                        this.itemsDiagnosis.diagcode11 = result.code;
                        this.itemsDiagnosis.diagCode11Description = result.description;
                        break;
                    case 'Diagnosis12':
                        this.itemsDiagnosis.diagcode12 = result.code;
                        this.itemsDiagnosis.diagCode12Description = result.description;
                        break;
                    case 'Diagnosis13':
                        this.itemsDiagnosis.diagcode13 = result.code;
                        this.itemsDiagnosis.diagCode13Description = result.description;
                        break;
                    case 'Diagnosis14':
                        this.itemsDiagnosis.diagcode14 = result.code;
                        this.itemsDiagnosis.diagCode14Description = result.description;
                        break;
                    case 'Diagnosis15':
                        this.itemsDiagnosis.diagcode15 = result.code;
                        this.itemsDiagnosis.diagCode15Description = result.description;
                        break;
                    case 'Diagnosis16':
                        this.itemsDiagnosis.diagcode16 = result.code;
                        this.itemsDiagnosis.diagCode16Description = result.description;
                        break;
                    case 'Diagnosis17':
                        this.itemsDiagnosis.diagcode17 = result.code;
                        this.itemsDiagnosis.diagCode17Description = result.description;
                        break;
                    case 'Diagnosis18':
                        this.itemsDiagnosis.diagcode18 = result.code;
                        this.itemsDiagnosis.diagCode18Description = result.description;
                        break;
                    case 'Diagnosis19':
                        this.itemsDiagnosis.diagcode19 = result.code;
                        this.itemsDiagnosis.diagCode19Description = result.description;
                        break;
                    case 'Diagnosis20':
                        this.itemsDiagnosis.diagcode20 = result.code;
                        this.itemsDiagnosis.diagCode20Description = result.description;
                        break;
                    case 'Diagnosis21':
                        this.itemsDiagnosis.diagcode21 = result.code;
                        this.itemsDiagnosis.diagCode21Description = result.description;
                        break;
                    case 'Diagnosis22':
                        this.itemsDiagnosis.diagcode22 = result.code;
                        this.itemsDiagnosis.diagCode22Description = result.description;
                        break;
                    case 'Diagnosis23':
                        this.itemsDiagnosis.diagcode23 = result.code;
                        this.itemsDiagnosis.diagCode23Description = result.description;
                        break;
                    case 'Diagnosis24':
                        this.itemsDiagnosis.diagcode24 = result.code;
                        this.itemsDiagnosis.diagCode24Description = result.description;
                        break;
                    default:
                        this.itemsDiagnosis.diagcode25 = result.code;
                        this.itemsDiagnosis.diagCode25Description = result.description;
                }
            }
        },

        Insert() {
            if (this.RecordId) {
                this.pendingChanges = false;
                DiagnosisService.Post(this.itemsDiagnosis)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            this.showMessage(
                                this.$t('Msg.Success'),
                                this.$t('Shared.SavedSuccessfully'),
                                'success'
                            );
                        }
                    })
                    .catch(error => {
                        if (!error.response) {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                this.$t('Msg.NotAbleToUpdate'),
                                'error'
                            );
                        } else {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                error.response.data.errorMessage,
                                'error'
                            );
                        }
                    });
            }
        },

        PrepareUpdatePatientDiagnosis() {
            return {
                DiagCode1: this.itemsDiagnosis.diagcode1,
                DiagCode2: this.itemsDiagnosis.diagcode2,
                DiagCode3: this.itemsDiagnosis.diagcode3,
                DiagCode4: this.itemsDiagnosis.diagcode4,
                DiagCode5: this.itemsDiagnosis.diagcode5,
                DiagCode6: this.itemsDiagnosis.diagcode6,
                DiagCode7: this.itemsDiagnosis.diagcode7,
                DiagCode8: this.itemsDiagnosis.diagcode8,
                DiagCode9: this.itemsDiagnosis.diagcode9,
                DiagCode10: this.itemsDiagnosis.diagcode10,
                DiagCode11: this.itemsDiagnosis.diagcode11,
                DiagCode12: this.itemsDiagnosis.diagcode12,
                DiagCode13: this.itemsDiagnosis.diagcode13,
                DiagCode14: this.itemsDiagnosis.diagcode14,
                DiagCode15: this.itemsDiagnosis.diagcode15,
                DiagCode16: this.itemsDiagnosis.diagcode16,
                DiagCode17: this.itemsDiagnosis.diagcode17,
                DiagCode18: this.itemsDiagnosis.diagcode18,
                DiagCode19: this.itemsDiagnosis.diagcode19,
                DiagCode20: this.itemsDiagnosis.diagcode20,
                DiagCode21: this.itemsDiagnosis.diagcode21,
                DiagCode22: this.itemsDiagnosis.diagcode22,
                DiagCode23: this.itemsDiagnosis.diagcode23,
                DiagCode24: this.itemsDiagnosis.diagcode24,
                DiagCode25: this.itemsDiagnosis.diagcode25
            };
        },

        async UpdatePatientDiagnosis() {
            await PatientService.update(this.PatientCode, this.PrepareUpdatePatientDiagnosis())
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.showMessage(
                            this.$t('Msg.Success'),
                            this.$t('Shared.SavedSuccessfully'),
                            'success'
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        Update() {
            if (this.RecordId) {
                this.pendingChanges = false;
                DiagnosisService.Put(this.RecordId, this.itemsDiagnosis)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            this.showMessage(
                                this.$t('Msg.Success'),
                                this.$t('Shared.SavedSuccessfully'),
                                'success'
                            );
                        }
                    })
                    .catch(error => {
                        if (!error.response) {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                this.$t('Msg.NotAbleToUpdate'),
                                'error'
                            );
                        } else {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                error.response.data.errorMessage,
                                'error'
                            );
                        }
                    });
            }
        },

        getDiagnosesByOutCome() {
            if (this.RecordId) {
                PatientService.getDiagnosesByOutCome(this.RecordId)
                    .then(response => {
                        if (response.status == '200' && response.data && response.data.length > 0) {
                            this.haveDiagnoses = true;
                        } else {
                            this.haveDiagnoses = false;
                        }
                    })
                    .catch(error => {
                        if (!error.response) {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                this.$t('Msg.RetrieveInformation'),
                                'error'
                            );
                        } else {
                            this.showMessage(this.$tc('Msg.Error'), error, 'error');
                        }
                    });
            }
        },

        Save() {
            this.haveDiagnoses ? this.Update() : this.Insert();
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        }
    },

    mounted() {
        this.getData();
        this.getDiagnosesByOutCome();
    },

    created() {
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
            }.bind(this)
        );
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    }
};
</script>
